import { MenuProps } from '../menu/interface'

export const searchList = [
  {
    value: 'open-api',
    label: 'open api',
  },
  {
    value: 'components',
    label: '组件',
  },
  {
    value: 'js-api',
    label: 'js api',
  }
]

export const headerMenus: MenuProps[] = [
  {
    hasNextFlag: "",
    id: "home_page",
    menuLevel: 0,
    menuUrl: "/home",
    pid: "",
    text: "首页",
  },
  {
    hasNextFlag: "",
    id: "js-doc",
    menuLevel: 0,
    menuUrl: "/doc-view",
    pid: "",
    text: "文档中心",
  },
  // {
  //   hasNextFlag: "",
  //   id: "js-component",
  //   menuLevel: 0,
  //   menuUrl: "/home",
  //   pid: "",
  //   text: "开放组件",
  // },
  // {
  //   hasNextFlag: "",
  //   id: "js-extends",
  //   menuLevel: 0,
  //   menuUrl: "https://open-cicd.zhi-niao.com/",
  //   pid: "",
  //   text: "集成平台",
  // },
  // {
  //   hasNextFlag: "",
  //   id: "community",
  //   menuLevel: 0,
  //   menuUrl: "/community",
  //   pid: "",
  //   text: "开发者社区",
  // },
]